import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { BrandsTrimsDTO } from './brands-trims.dto';
export class MasterBrandDTO {
    @ApiProperty()
    @IsOptional()
    masterBrandId?: number;
    @ApiProperty()
    @IsNotEmpty({message:"Name should not be empty"})
    masterBrandName: string;
    @ApiProperty()
    filePath: string;
    @ApiProperty()
    fileName: string;
    @ApiProperty()
    isPouchVariantConsider:string;
    @ApiProperty()
    isPouchBapNoConsider:string;
    @ApiProperty()
    isPouchGradeConsider:string;
    @ApiProperty()
    isPouchValAddOneConsider:string;
    @ApiProperty()
    isPouchValAddTwoConsider:string;
    @ApiProperty()
    isPouchValAddThreeConsider:string;
    @ApiProperty()
    isPouchValAddFourConsider:string;
    @ApiProperty()
    isPouchValAddFiveConsider:string;
    @ApiProperty()
    isPouchFoodTypeConsider:string;
    @ApiProperty()
    isPouchProductConsider:string;

    @ApiProperty()
    isCartonVariantConsider:string;

    @ApiProperty()
    isCartonBapNoConsider:string;

    @ApiProperty()
    isCartonGradeConsider:string;
    @ApiProperty()
    isCartonValAddOneConsider:string;
    @ApiProperty()
    isCartonValAddTwoConsider:string;
    @ApiProperty()
    isCartonValAddThreeConsider:string;
    @ApiProperty()
    isCartonValAddFourConsider:string;
    @ApiProperty()
    isCartonValAddFiveConsider:string;
    @ApiProperty()
    isCartonFoodTypeConsider:string;
    @ApiProperty()
    isCartonProductConsider:string;
    @ApiProperty()
    displayBrandName: string;
    @ApiProperty({type:[BrandsTrimsDTO]})
    trimsInfo?:BrandsTrimsDTO[];
    @ApiProperty()
    isActive: boolean;
    createdAt : Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Created User allows maximum 40 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
    createdUser : string;

    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
    updatedUser : string;

    @ApiProperty()
    versionFlag : number;
    
}

